import { ValidatorFn, AbstractControl, FormArray, FormGroup } from '@angular/forms';

export class EitherValidator {

  public static either(): ValidatorFn | any {
    return (control: FormGroup) => {
      if (control) {
        if (control.controls.client_domain.value || control.controls.system_domain.value) {
          return null;
        }
      }
      return { either: true };
    };
  }

  public static eitherTwo(): ValidatorFn | any {
    return (control: FormGroup) => {
      if (control) {
        if (control.controls.fixedValue.value || control.controls.systemField.value) {
          return null;
        }
      }
      return { either: true };
    };
  }
}
